$('.js-card-menu').on('click', function(e) {
	e.preventDefault();

	$('.card-color__menu').removeClass('hidden');
	
	$('.js-menu-color').animate({
		right: 0,
		opacity: 1
	}, 500);


	$('body').addClass('no-scroll');
	$('.card-color__menu').addClass('menu-scroll');
})